<div class="overlay animated fadeIn" *ngIf="this.parent.hasSearchResults()" (click)="this.parent.closeSearchResults();"></div>

<div *ngIf="this.parent.mainLoading != true;">
<div class="WelcomeTitle">
  {{'PriceListWelcomeTitle' | translate}}
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'AllPricesNetPrices' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'RFQBasicInfo' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'AllGreenPOPossibility' | translate}}</span>
</div>

<div class="ListPriceBrandsContainer">
  <div *ngIf="this.loadingBrandIcons != true;">
    <div class="ListPriceBrand" *ngFor="let b of this.Brands; let i = index;" matTooltip="({{b.Name}}) {{'AvailableUntil' | translate}}: {{b.AvailabilityDateUI}}" matTooltipClass='neutral-tool-tip'>
      <div class="BrandImage">
        <img [src]="this.parent.BackendServiceUrl + b.LogoPath">
      </div>
      <div class="BrandEventRegister">
        {{b.Name}}
      </div>
      <div class="BrandEventRegister">
        {{'AvailableUntil' | translate}}
      </div>
      <div class="BrandEventRegister">
        {{b.AvailabilityDateUI}}
      </div>
    </div>
  </div>
  <div *ngIf="this.loadingBrandIcons == true;" class="brandSpinnerContainer">
    <mat-spinner class="brandSpinner" [diameter]="25"></mat-spinner>
  </div>
</div>

<!-- <div class="WelcomeMessage" *ngIf="this.ShowSearchProductsPageMessage == true && this.B2BHomePageMessage?.length > 0;">
  <div class="WelcomeMessageTitle unSelectable">
    <i class="material-icons">info_outline</i>
    {{'Notice' | translate}}
  </div>
  <div class="WelcomeMessageClose" (click)="CloseShowSearchProductsPageMessage();">
    <i class="material-icons">close</i>
  </div>
  <div class="WelcomeMessageBody">
    {{this.B2BHomePageMessage}}
  </div>
</div> -->

<div class="overlay dashOverlay" *ngIf="this.parent.itemOverlay == true;" (click)="this.parent.CloseItemOverlay();"></div>

<!-- <div class="B2BBodyTopSearchContainer">
    <p class="B2BBodyTopSearchContainerTitle">{{'SearchProducts' | translate}}</p>
    <div class="CentralSearchContainer">
      <mat-spinner *ngIf="loadingProducts" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
      <input type="text" class="CentralSearch" placeholder="ex: 6GK5005-0BA00-1AB2" (click)="InitializeSearchProduct();" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
      <i class="material-icons" *ngIf="!(this.Filter?.SearchTerm?.length > 0) && !loadingProducts;">search</i>
      <i class="material-icons" style="color:red;" *ngIf="this.Filter?.SearchTerm?.length > 0 && !loadingProducts;" (click)="this.SearchTerm = ''; this.SearchedProducts.length = 0; this.Filter.SearchTerm = '';">close</i>
    
      <div class="CentralSearchResultsContainer" *ngIf="SearchedProducts?.length > 0;">
        <div *ngFor="let p of this.SearchedProducts;" class="CentralSearchResult" (click)="this.parent.AddNewCartItem(p); this.SearchedProducts = [];">
          {{p.FKBrandName}} {{p.ProductName}}
          <span *ngIf="p.ProductPartNumber?.length > 0 && p.ProductPartNumber != p.Name;">({{p.ProductPartNumber}})</span>
        </div>
      </div>
    </div>
</div> -->

<div class="ColorGuideContainer">

  <div class="ColorGuideContainerTitle">
    <i class="material-icons">info_outline</i>
    <span>{{'UsageInstructions' | translate}}</span>
  </div>

  <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #32aa3a;">
    </div>
    <div class="ColorGuideSpan" style="background: #d2fed2;">
      {{'ValidRow' | translate}}
    </div>
  </div>

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #aaa;">
    </div>
    <div class="ColorGuideSpan" style="background: #ddd;color: #000;">
      {{'InvalidRow' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #ff8987!important;">
    </div>
    <div class="ColorGuideSpan" style="background: #ff8987!important;color: #000;">
      {{'UnknownProduct' | translate}}
    </div>
  </div> -->

  <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #f60;">
    </div>
    <div class="ColorGuideSpan" style="background: #ffcaa1;color: #000;">
      {{'AwaitingSelectionRow' | translate}}
    </div>
  </div>
</div>

<div class="GridTotals" *ngIf="this.parent.Cart?.Currency?.ID > 0;">
   <span class="IntegerSpan" style="margin-right: 10px;">Total:</span> <span class="IntegerSpan">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer}}</span><span class="DecimalSpan">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals}}</span><span class="IntegerSpan">{{this.parent.Cart?.Currency?.Name}}</span> 
</div>

<div class="GridCommandCenter">
  <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #4d148c;" (click)="this.parent.ExportB2BGrid();">
    <i class="material-icons">downloading</i>
    <span>{{'DownloadExcel' | translate}}</span>
  </button>

  <button mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" (click)="this.parent.DownloadOfficialOffer();">
    <i class="material-icons">attach_file</i>
    <span>{{'DownloadOfficialOffer' | translate}}</span>
  </button>

  <button disabled="true" mat-flat-button color="primary" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID == -1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button (click)="this.parent.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 1;">
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button (click)="this.parent.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 0;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button disabled="true" mat-stroked-button color="primary" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID != 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">check</i>
    <span>{{'SendPO' | translate}}</span>
  </button>

  <button (click)="this.parent.OpenAskAddNewRFQasPOQuestion();" mat-stroked-button color="primary" class="AddRowsButton AddNewPOButton" style="color: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">check</i>
    <span>{{'SendPO' | translate}}</span>
  </button>

  <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #fd4f57; float: right;" (click)="this.parent.AskClearGridQuestion();">
    <i class="material-icons">close</i>
    <span>{{'ClearGrid' | translate}}</span>
  </button>

  <!-- <mat-form-field class="OfferPriorityStatusesSelect" appearance="outline">
    <mat-label>{{ 'SelectOfferPriority' | translate }}</mat-label>
    <mat-select name="Language" [compareWith]="parent.compareFn" [(ngModel)]="this.parent.OfferPriorityStatus">
      <mat-option *ngFor="let prio of this.parent.OfferPriorityStatuses; index as i" [value]="prio">
        {{prio.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
</div>

<div class="GridContainer unSelectable">
  <div class="GridRow">
    <!-- <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px); background: #fff;">
      <mat-checkbox class="GridCheckBox" [(ngModel)]="this.parent.SelectedGrid" (change)="this.parent.SelectAll();"></mat-checkbox>
    </div> -->
    <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);">
      #
    </div>

    <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(10%);">
      {{'Brand' | translate}}
    </div>

  <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(30%);" matTooltip="{{ 'ProductNamePartNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
     {{'ProductNamePartNumber' | translate}}
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);">
    {{'Quantity' | translate}}
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(7.5%);">
    {{'Price' | translate}}
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(7.5%);">
    {{'Total' | translate}}
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10%);">
    {{'ETA' | translate}}
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(8%);">
      HSCode
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);">
      COO
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(7%);">
      {{'Weight' | translate}}
  </div>

  <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);border-right: solid 1px #aaa;">
    {{'Actions' | translate}}
  </div>
  </div>

  <div class="GridRow" *ngFor="let item of this.parent.CartItemRows; let i = index;">
    <!-- <div class="GridCol" style="width: Calc(5% - 2px); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (mouseover)="this.parent.handleMouseOver($event, item)" (mousedown)="this.parent.handleMouseDown()" (mouseup)="this.parent.handleMouseUp()" (mouseleave)="this.parent.handleMouseLeave()">
      <mat-checkbox class="GridCheckBox" [(ngModel)]="item.IsSelected"></mat-checkbox>
    </div> -->
    <div class="GridCol" style="width: Calc(5% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
      {{i + 1}}
    </div>

    <div class="GridCol leftText" style="width: Calc(10%);  cursor: pointer;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (click)="this.parent.InitializeSearchProduct(item);">
      <span *ngIf="item?.CartItemStatus?.ID >= 0;">{{item?.Product?.Brand?.Name}}</span>
      <span *ngIf="item?.CartItemStatus?.ID == -1;">{{'ItemNeedsSelection' | translate}}</span>
      <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null;">
        <i class="material-icons SelectBrandIcon">keyboard_arrow_down</i>
        {{'SelectBrand' | translate}}
      </span>

      <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null;">
        {{item?.UserSelectedBrand?.Name}}
      </span>

      <div *ngIf="item.ShowBrandSearchResults == true;" class="GridBrandSearchResults">
        <div class="GridBrandSearchResultsTopSearch">
          <input type="text" placeholder="ex: SIEMENS" [(ngModel)]="this.parent.brandSearch" class="GridBrandSearchInput" matInput (ngModelChange)="this.parent.GetBrandsFilteredWithSuggestion(this.parent.brandSearch);"/>
        </div>
        <div class="GridBrandSearchResultsBody" *ngIf="this.parent.BrandsLoading != true;">
          <div class="GridBrandSearchRow" *ngFor="let brand of this.parent.Brands; let b = index;" (click)="this.parent.SelectItemBrand(item, brand);">
            <span>{{brand.Name}}</span>
          </div>
        </div>
        <mat-spinner *ngIf="this.parent.BrandsLoading == true;" diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
      </div>
    </div>

    <div class="GridCol leftText" style="width: Calc(30%); background: #fff;padding-left: 0!important; cursor: pointer;" [ngClass]="{'awaitingChoiceMarkedRows': item?.CartItemStatus?.ID == -1, 'notFoundMarkedRows': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'validMarkedRows': item?.CartItemStatus?.ID == 1, 'invalidMarkedRows': item?.CartItemStatus?.ID == 0, 'blinking-background': item.LoadingCell == true}">
      <textarea [disabled]="item.LoadingCell" class="GridColFullText" type="text" (click)="this.parent.InitializeSearchProduct(item);" [(ngModel)]="item.UIProductValue" matInput (ngModelChange)="this.parent.searchTermUpdate.next($event)"></textarea>
      <i class="material-icons cellCheckIcon" *ngIf="item?.CartItemStatus?.ID == 1;">check</i>
      <i class="material-icons cellDownIcon" *ngIf="item?.CartItemStatus?.ID == -1;">keyboard_arrow_down</i>
      <div *ngIf="item.ShowSearchResults == true && item?.SearchResults?.length > 0;" class="itemChoiceContainer">
        <div class="itemChoiceContainerTitle">{{'SimilarProducts' | translate}}</div>
        <div *ngFor="let s of this.item.SearchResults; let j = index;" class="cellSearchResultRow" (click)="this.parent.SelectGridSearchResult(s, item);" [ngClass]="{'SelectedOfferRow': s.IsSelected == true}">
          <span>{{s.FKBrandName}}</span>  
          <span>{{s.ProductName}}</span> <span *ngIf="s.ProductPartNumber?.length > 0;">(PN: {{s.ProductPartNumber}})</span>
          <i class="material-icons SelectedGridSearchResult" *ngIf="s.IsSelected == true;">check</i>
        </div>
      </div>
    </div>

    <div class="GridCol" style="width: Calc(5%); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
      <div class="MOQSign" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true" matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
      <input style="text-align: center; width: 100%; margin:0%;" class="GridColFullText" type="text" [(ngModel)]="item.Quantity" matInput *ngIf="item.Quantity > 0" (ngModelChange)="this.parent.OnlyNumbers($event)" (change)="this.parent.ChangeGridCellItem(item);"/>
    </div>

    <div class="GridCol" style="width: Calc(7.5%);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
      <div (click)="this.parent.PrepareGridCellItemSideOffers(item);" class="SpecialOfferSign" *ngIf="item?.SelectedOffer?.SpecialOffer?.SpecialOfferPrice > 0;" matTooltip="Special: {{item?.SelectedOffer?.SpecialOffer?.SpecialOfferPrice}} {{item?.SelectedOffer?.SpecialOffer?.Currency?.Name}} - min. x{{item?.SelectedOffer?.SpecialOffer?.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
      {{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Symbol}}
    </div>

    <div class="GridCol" style="width: Calc(7.5%);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
      {{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Symbol}}
    </div>

  <div class="GridCol" style="width: Calc(10%);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
    <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == -1" style="background: #f60;" matTooltip="{{item.RequestDeliveryStatus?.Description}}" matTooltipClass='neutral-tool-tip'></span>
    <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 0" style="background: #32aa3a;" matTooltip="{{item.RequestDeliveryStatus?.Description}}" matTooltipClass='neutral-tool-tip'></span>
    <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 1" matTooltip="{{item.RequestDeliveryStatus?.Description}}" matTooltipClass='neutral-tool-tip'></span>
    <span *ngIf="item.SelectedOffer?.LeadTime != null;">{{item.SelectedOffer?.LeadTime?.Units}} {{item.SelectedOffer?.LeadTime?.Type?.Name}}</span>
    <span *ngIf="item.SelectedOffer?.LeadTime == null;">------</span>
    <div matTooltip="{{'DeliveryOptions' | translate}}" matTooltipClass='neutral-tool-tip' (click)="this.parent.PrepareGridCellItemSideOffers(item);" *ngIf="item.Product?.ListPriceOffers?.length > 1;" class="StockOptionsButton">
      <i class="material-icons">settings</i>
    </div>
  </div>

  <div class="GridCol" style="width: 8%;">
    {{item.Product?.Stats?.HSCode}}
  </div>

  <div class="GridCol" style="width: 5%;">
    {{item.Product?.Stats?.COO?.ShortName}}
  </div>

  <div class="GridCol" style="width: 7%;">
    {{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}
  </div>

  <div class="GridCol" style="width: Calc(5%);border-right: solid 1px #aaa; background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
    <i class="material-icons RemoveItemGridIcon" (click)="this.parent.RemoveItem(item);">close</i>
  </div>
  </div>

  <button mat-flat-button color="primary" (click)="this.parent.PopulateCartItems(1)" class="AddRowsButton" style="background: #4d148c;">
    <i class="material-icons">add</i>
    <span> 1 {{'Rows' | translate}}</span>
  </button>

  <button mat-flat-button color="primary" (click)="this.parent.PopulateCartItems(10)" class="AddRowsButton" style="background: #4d148c;">
    <i class="material-icons">add</i>
    <span> 10 {{'Rows' | translate}}</span>
  </button>

  <button mat-flat-button color="primary" (click)="this.parent.PopulateCartItems(50)" class="AddRowsButton" style="background: #4d148c;">
    <i class="material-icons">add</i>
    <span> 50 {{'Rows' | translate}}</span>
  </button>
</div>
</div>